"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardMapToken = void 0;
var KeyboardMap_1 = require("./KeyboardMap");
var KeyboardMapToken = /** @class */ (function () {
    function KeyboardMapToken(pFocusable, pUp, pDown, pLeft, pRight) {
        this.target = pFocusable;
        this.neighbours = new Array(KeyboardMap_1.Direction.NUM_ELEMENTS);
        this.neighbours[KeyboardMap_1.Direction.UP] = pUp;
        this.neighbours[KeyboardMap_1.Direction.DOWN] = pDown;
        this.neighbours[KeyboardMap_1.Direction.LEFT] = pLeft;
        this.neighbours[KeyboardMap_1.Direction.RIGHT] = pRight;
    }
    /**
     * @return a set of KeyboardMapToken that makes a row in keyboard navigation
     * @param pFocusables - the array of focusables aligned in a row
     * @param pUp - the outer focusable to navigate on up key
     * @param pDown - the outer focusable to navigate on down key
     * @param pLeft - the outer focusable to navigate on left key
     * @param pRight - the outer focusable to navigate on right key
     */
    KeyboardMapToken.getRow = function (pFocusables, pUp, pDown, pLeft, pRight) {
        var tokens = [];
        for (var i = 0, n = pFocusables.length; i < n; i++) {
            tokens.push(new KeyboardMapToken(pFocusables[i], pUp, pDown, i === 0 ? pLeft : pFocusables[i - 1], i === n - 1 ? pRight : pFocusables[i + 1]));
        }
        return tokens;
    };
    /**
     * @return a set of KeyboardMapToken that makes a column in keyboard navigation
     * @param pFocusables - the array of focusables aligned in a column
     * @param pUp - the outer focusable to navigate on up key
     * @param pDown - the outer focusable to navigate on down key
     * @param pLeft - the outer focusable to navigate on left key
     * @param pRight - the outer focusable to navigate on right key
     */
    KeyboardMapToken.getColumn = function (pFocusables, pUp, pDown, pLeft, pRight) {
        var tokens = [];
        for (var i = 0, n = pFocusables.length; i < n; i++) {
            tokens.push(new KeyboardMapToken(pFocusables[i], i === 0 ? pUp : pFocusables[i - 1], i === n - 1 ? pDown : pFocusables[i + 1], pLeft, pRight));
        }
        return tokens;
    };
    /**
     * @return a set of KeyboardMapToken that makes a table in keyboard navigation
     * @param pFocusables - the array of focusables aligned in a table like:
     * [
     *  [a,b,c],
     *  [d,e,f]
     * ]
     * @param pUp - the outer focusable to navigate on up key
     * @param pDown - the outer focusable to navigate on down key
     * @param pLeft - the outer focusable to navigate on left key
     * @param pRight - the outer focusable to navigate on right key
     */
    KeyboardMapToken.getTable = function (pFocusables, pUp, pDown, pLeft, pRight) {
        var tokens = [];
        for (var i = 0, n = pFocusables.length; i < n; i++) {
            for (var j = 0, m = pFocusables[i].length; j < m; j++) {
                tokens.push(new KeyboardMapToken(pFocusables[i][j], i === 0 ? pUp : pFocusables[i - 1][j], i === n - 1 ? pDown : pFocusables[i + 1][j], j === 0 ? pLeft : pFocusables[i][j - 1], j === m - 1 ? pRight : pFocusables[i][j + 1]));
            }
        }
        return tokens;
    };
    return KeyboardMapToken;
}());
exports.KeyboardMapToken = KeyboardMapToken;
//# sourceMappingURL=KeyboardMapToken.js.map